<template>
   <div class="flex min-h-60 max-w-7xl items-center justify-center text-center md:min-h-[27rem] md:max-w-md">
      <div>
         <h1 class="text-2xl text-lighter leading-normal md:text-4xl md:leading-snug">{{ headingWithName }}</h1>
         <h2 v-if="subheading" class="text-2xl text-lighter leading-normal md:text-4xl md:leading-snug">
            {{ subheading }}
         </h2>
      </div>
   </div>
</template>

<script setup lang="ts">
// props
// -----------------------------------------
interface Props {
   // we might not have a name (ex new portal user)
   userName?: string;
   type: "greeting_section";
   heading: string;
   subheading: string;
   margin?: string;
}
const props = defineProps<Props>();

// computed
// -----------------------------------------
const headingWithName = computed(() => {
   return props.heading.replace("{optional_first_name}", props.userName ? ` ${props.userName}` : "");
});
</script>

<style scoped lang="scss"></style>
